import React from 'react';
import styled from '@emotion/styled';
import { colors, typography, } from '@argo/principles';
import { AwardImage, } from '../../sew-common';

const CssVehicleDisplayName = styled.div`
  font-size: 16px;
  line-height: 19px;
  font-family: ${typography.family.montserrat};
  color: ${colors.primary.black};
  font-weight: ${typography.weight.bold};
  padding-bottom: 4px;
`;

const CssAwardName = styled.div`
  font-size: 14px;
  line-height: 19px;
  font-family: ${typography.family.montserrat};
  color: ${colors.primary.charcoal};
  font-weight: ${typography.weight.regular};
  padding-bottom: 4px;
`;

const Award = ({ award, }: any,) => {
  const { vehicleYear, vehicleMake, vehicleModel, awardName, awardCode, } = award;
  const vehicleDisplayName = `${vehicleYear} ${vehicleMake} ${vehicleModel}`;

  return (
    <>
      <AwardImage awardCode={awardCode} />
      <CssVehicleDisplayName>
        {vehicleDisplayName}
      </CssVehicleDisplayName>
      <CssAwardName>
        {`Winner – ${awardName}`}
      </CssAwardName>
    </>
  );
};

export default Award;
